import * as actionTypes from '@store/actions/actionTypes'

const initialState = {
  selected: null
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CONTACT:
      return {
        ...state,
        selected: action.data
      }
    default:
      return state
  }
}

export default reducer
